import { readonly, useRoute, useRuntimeConfig, useState } from "#imports";
import { getMidByPriority, validateMid } from "../utils/mid.js";
export default function useMid(route) {
  const activeMid = useState("activeMid", () => "");
  const midPinned = useState("midPinned", () => false);
  const config = useRuntimeConfig();
  try {
    const routeToUse = route || useRoute();
    const queryMid = typeof routeToUse.query.mid === "string" ? routeToUse.query.mid : "";
    const midFromUrl = !midPinned.value && validateMid(queryMid) ? queryMid : null;
    const defaultMid = typeof config.public.DEFAULT_MID === "string" ? config.public.DEFAULT_MID : "";
    const midByPriority = getMidByPriority({
      activeMid: activeMid.value,
      midFromUrl,
      defaultMid
    });
    if (midByPriority !== activeMid.value) {
      activeMid.value = midByPriority;
    }
  } catch {
  }
  function setMid(newMid) {
    if (validateMid(newMid)) {
      activeMid.value = newMid;
    }
  }
  function resetMid(defaultMid) {
    const fallback = typeof config.public.DEFAULT_MID === "string" ? config.public.DEFAULT_MID : "";
    activeMid.value = defaultMid ?? fallback;
  }
  return { mid: readonly(activeMid), setMid, resetMid };
}
